/** Session handoff: main menu reads this and runs coin “doobers” into the HUD. */
export const CWF_COIN_FLY_STORAGE_KEY = "cwf_pendingCoinFly";

/** One-shot splash when returning to home from an active duel. */
const CWF_MENU_FROM_DUEL_KEY = "cwf_menu_from_duel";

export function flagMenuTransitionFromDuel(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(CWF_MENU_FROM_DUEL_KEY, "1");
  } catch {
    /* quota / private mode */
  }
}

export function readMenuTransitionFromDuel(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return sessionStorage.getItem(CWF_MENU_FROM_DUEL_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearMenuTransitionFromDuel(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(CWF_MENU_FROM_DUEL_KEY);
  } catch {
    /* no-op */
  }
}

export function setPendingCoinFlyToHud(amount: number): void {
  if (typeof window === "undefined") return;
  const n = Math.max(0, Math.round(Number(amount)));
  if (n <= 0) return;
  let cur = 0;
  try {
    const raw = window.sessionStorage.getItem(CWF_COIN_FLY_STORAGE_KEY);
    if (raw) {
      const p = JSON.parse(raw) as { amount?: number };
      if (typeof p.amount === "number" && Number.isFinite(p.amount)) {
        cur = Math.max(0, Math.round(p.amount));
      }
    }
  } catch {
    /* noop */
  }
  try {
    window.sessionStorage.setItem(
      CWF_COIN_FLY_STORAGE_KEY,
      JSON.stringify({ amount: cur + n }),
    );
  } catch {
    /* quota / private mode */
  }
}

/** Read queued coin fly amount from sessionStorage and clear the key — used once on `/`. */
export function consumePendingCoinFlyAmount(): number {
  if (typeof window === "undefined") return 0;
  let raw: string | null = null;
  try {
    raw = window.sessionStorage.getItem(CWF_COIN_FLY_STORAGE_KEY);
  } catch {
    return 0;
  }
  if (!raw) return 0;
  try {
    window.sessionStorage.removeItem(CWF_COIN_FLY_STORAGE_KEY);
  } catch {
    /* noop */
  }
  try {
    const p = JSON.parse(raw) as { amount?: number };
    return typeof p.amount === "number" && Number.isFinite(p.amount)
      ? Math.max(0, Math.round(p.amount))
      : 0;
  } catch {
    return 0;
  }
}

/** Fires while AppShell is mounted — use when already on a screen with the HUD (e.g. daily reward claim). */
export const CWF_COIN_FLY_HUD_EVENT = "cwf-coin-fly-hud";

export function emitCoinFlyToHud(amount: number): void {
  if (typeof window === "undefined") return;
  const n = Math.max(0, Math.round(Number(amount)));
  if (n <= 0) return;
  window.dispatchEvent(
    new CustomEvent(CWF_COIN_FLY_HUD_EVENT, { detail: { amount: n } }),
  );
}
